<template>

<com-item name="hindex.games" :is-cards="true" :size="size" :loading="loading" class="games" title="Games">
	
	<template v-slot:about>

		<p>The games on your H-index and when they were last played.</p>

	</template>

	<template v-slot:stats>

        <com-card :item="item" :tag="(item.c >= threshold) ? 'Cornerstone' : false" :subtitle="'Since Level ' + item.a" tag-theme="normalblue" v-for="item in data.level" :key="item.g" :id="item.g" :name="$store.getters['data/games/associated'][item.g].name" class="card">

            <core-card-foot-stat :value="item.c" text="play" :plural="true" />

            <core-card-foot-date :value="item.f" text="first play" />

            <core-card-foot-date :value="item.d" text="last play" />

        </com-card>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comCard from './../common/Card'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
        'com-card': comCard
	},

	computed: {

		loading: function() {
		
			return this.fetching
		
		},

		threshold: function() {

			return this.$store.getters['page/insights/hindex/summary'].current.hindex * 2

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/games']

		},

		active: function() {

			return this.data.level.length && !this.loading

		}

	},

	methods: {

		subtext: function(value) {

			return 'Last played on ' + this.$options.filters.formatDate(value, this.$util.date.format('Do', 'MMMM', 'YYYY'))

		},

		onMoreClick: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsHindexGames'
			})

		}
	
	}

}

</script>

<style scoped>

</style>